function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint no-fallthrough: 0 */

/* eslint default-case: 0 */
import PayByLinkRequiredFields from '@engine/features/virtual_terminal/vt_update_pay_by_link_required_fields';
import RequiredFields from '@engine/features/virtual_terminal/vt_update_required_fields';
import { exists } from 'js/lib/utility/exists';
import gateway from '@engine/features/virtual_terminal/vt_gateway';
import { options } from 'js/features/apply_chosen';

function hasSelectedPaymentType(type) {
  return $("#pay_by_link_transaction_type_".concat(type)).prop('checked');
}

function updateEzeeWalletFields() {
  var isTransactionWithEzeeWalletTypeInRequest = hasSelectedPaymentType('ezeewallet');

  if (isTransactionWithEzeeWalletTypeInRequest) {
    $('#ezeewallet_type').removeClass('hidden');
  } else {
    $('#ezeewallet_type').addClass('hidden');
  }
}

function hasSelectedTrxTypeWithPaymentType() {
  var TRANSACTION_TYPES_WITH_PAYMENT_TYPE = ['pay_pal'];

  for (var _i = 0, _TRANSACTION_TYPES_WI = TRANSACTION_TYPES_WITH_PAYMENT_TYPE; _i < _TRANSACTION_TYPES_WI.length; _i++) {
    var transaction_type = _TRANSACTION_TYPES_WI[_i];

    if ($('#pay_by_link_transaction_type_' + transaction_type).prop('checked')) {
      return true;
    }
  }

  return false;
}

function hasSelectedTrxTypeWithPaymentSubtype() {
  var MOBILE_TOKENIZED_TRX_TYPES = ['google_pay', 'apple_pay'];

  for (var _i2 = 0, _MOBILE_TOKENIZED_TRX = MOBILE_TOKENIZED_TRX_TYPES; _i2 < _MOBILE_TOKENIZED_TRX.length; _i2++) {
    var transaction_type = _MOBILE_TOKENIZED_TRX[_i2];

    if ($('#pay_by_link_transaction_type_' + transaction_type).prop('checked')) {
      return true;
    }
  }

  return false;
}

function paymentSubtypesForSelectedTransaction() {
  var allPaymentTypes = ['authorize', 'init_recurring_sale', 'sale'];
  var unsupportedPaymentTypes = [];

  switch (true) {
    case $('#pay_by_link_transaction_type_apple_pay').prop('checked'):
      unsupportedPaymentTypes.push('sale');
      break;
  }

  return allPaymentTypes.filter(function (paymentType) {
    return !unsupportedPaymentTypes.includes(paymentType);
  });
}

function paymentTypesForSelectedTransaction() {
  var allPaymentTypes = ['authorize', 'init_recurring_sale', 'sale'];
  var unsupportedPaymentTypes = [];

  switch (true) {
    case $('#pay_by_link_transaction_type_pay_pal').prop('checked'):
      unsupportedPaymentTypes.push('init_recurring_sale');
      break;
  }

  return allPaymentTypes.filter(function (paymentType) {
    return !unsupportedPaymentTypes.includes(paymentType);
  });
}

function updatePaymentTypeSelect() {
  var isWithSubtype = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var paymentTypeSelect = null;
  var selectedPaymentType = null;
  var availablePaymentTypes = null;
  var emptyValue = '<option value="">' + I18n.t('javascript.options.please_select') + '</option>';

  if (isWithSubtype) {
    paymentTypeSelect = $('#pay_by_link_payment_subtype');
    selectedPaymentType = $('#pay_by_link_payment_subtype :selected').val();
    availablePaymentTypes = paymentSubtypesForSelectedTransaction();
  } else {
    paymentTypeSelect = $('#pay_by_link_payment_type');
    selectedPaymentType = $('#pay_by_link_payment_type :selected').val();
    availablePaymentTypes = paymentTypesForSelectedTransaction();
  }

  paymentTypeSelect.empty();
  paymentTypeSelect.append(emptyValue);

  var _iterator = _createForOfIteratorHelper(availablePaymentTypes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var paymentType = _step.value;
      var option = $('<option/>').attr('value', paymentType).text(paymentType);

      if (paymentType === selectedPaymentType) {
        option.attr('selected', 'selected');
      }

      paymentTypeSelect.append(option);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  paymentTypeSelect.addClass('for_chosen').chosen(options);
  paymentTypeSelect.trigger('chosen:updated');
}

function updatePaymentTypeFields() {
  var isTransactionWithPaymentTypeInRequest = hasSelectedTrxTypeWithPaymentType();

  if (isTransactionWithPaymentTypeInRequest) {
    $('#payment_type').removeClass('hidden');
    updatePaymentTypeSelect(false);
  } else {
    $('#payment_type').addClass('hidden');
  }
}

function updatePaymentSubtypeFields() {
  var isTransactionWithPaymentSubtypeInRequest = hasSelectedTrxTypeWithPaymentSubtype();

  if (isTransactionWithPaymentSubtypeInRequest) {
    $('#payment_subtype').removeClass('hidden');
    updatePaymentTypeSelect(true);
  } else {
    $('#payment_subtype').addClass('hidden');
  }
}

function updateFitbankPixOptionalFields() {
  var fieldIds = ['pay_by_link_mothers_name', 'optional_birth_date_params', 'gender', 'marital_status', 'pay_by_link_sender_occupation', 'pay_by_link_nationality', 'country_of_origin', 'pay_by_link_birth_city', 'pay_by_link_birth_state', 'optional_incorporation_date_params', 'company_type', 'pay_by_link_company_activity'];

  if (gateway.name === 'FitBank' && hasSelectedPaymentType('pix')) {
    fieldIds.forEach(RequiredFields.makeDivVisible);
  } else {
    fieldIds.forEach(RequiredFields.makeDivHidden);
  }
}

function listenForTransactionTypeChange() {
  var transactionTypesContainer = '.transaction-types-container';

  if (exists($(transactionTypesContainer))) {
    updatePaymentTypeFields();
    updatePaymentSubtypeFields();
    PayByLinkRequiredFields.toggleForExpressCheckout();
    updateEzeeWalletFields();
    updateFitbankPixOptionalFields();
    $(transactionTypesContainer).on('change', function () {
      updatePaymentTypeFields();
      updatePaymentSubtypeFields();
      PayByLinkRequiredFields.toggleForExpressCheckout();
      updateEzeeWalletFields();
      updateFitbankPixOptionalFields();
    });
  }
}

var PayByLinkPaymentType = {
  updateFields: updatePaymentTypeFields,
  listenForChange: listenForTransactionTypeChange
};
export default PayByLinkPaymentType;